import { apolloZindexDialog } from "@nexthink/apollo-tokens";
import styled from "styled-components";
export const getDropDownStyles = (theme, isOpen) => ({
    boxShadow: theme.colors.apolloBoxShadowDropdownMenu,
    borderRadius: "4px",
    display: isOpen ? "block" : "none",
    overflow: "hidden",
    zIndex: apolloZindexDialog,
});
export const StyledDropdown = styled.div.withConfig({ displayName: "StyledDropdown_APC-7311-productShell", componentId: "sc-8h33ce" })(({ theme }) => (Object.assign(Object.assign({}, getDropDownStyles(theme, true)), { height: undefined, width: undefined })));
//# sourceMappingURL=Dropdown.style.js.map